import { render } from "./P404.vue?vue&type=template&id=74d48388"
import script from "./P404.vue?vue&type=script&lang=js"
export * from "./P404.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__